import React from "react";
import { ResponsiveImage } from "@quintype/components";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import "./image-gallery.m.css";

const ImageGallery = ({ element }) => {
  const totalLength = element["story-elements"].length;
  const itemsList = element["story-elements"].slice(0, 6);
  const remainingCount = Number(totalLength - itemsList.length);
  const allImages = element["story-elements"];

  if (!totalLength) return null;
  const CdnImage = "https://images.deccanherald.com/";

  const GROUP1 = allImages;

  const PhotoItem = ({ image, thumb, group, index }) => (
    <div styleName="qt-image-1x1">
      <LightgalleryItem
        group={group}
        key={index}
        src={CdnImage + image["image-s3-key"]}
        thumb={CdnImage + image["image-s3-key"]}
        subHtml={`<p>
        <span class="gallery-image-title" >${image.title}</span>
        <span class="gallery-image-attribution" style="font-weight: bold; color: #dddddd; margin-left:10px;">
        ${image["image-attribution"] && image["image-attribution"]}
        </span>
        </p>`}
      >
        <ResponsiveImage
          slug={decodeURIComponent(image["image-s3-key"])}
          metadata={image["image-metadata"]}
          aspectRatio={[1, 1]}
          defaultWidth={480}
          widths={[250, 480, 640]}
          imgParams={{ auto: ["format", "compress"], fmt: "webp" }}
          alt={image["image-attribution"] || image.title || ""}
        />
        {index === 5 && remainingCount ? <div styleName="count">+{remainingCount}</div> : null}
      </LightgalleryItem>
    </div>
  );

  return (
    <div styleName="wrapper">
      <LightgalleryProvider>
        {totalLength &&
          allImages.map((image, index) => (
            <>
              {index <= 5 && <PhotoItem key={index} image={image} group="GROUP1" index={index} />}
              {index >= 6 && (
                <div styleName="lightbox-no-image">
                  <PhotoItem key={index} image={image} group="GROUP1" index={index} />
                </div>
              )}
            </>
          ))}
      </LightgalleryProvider>
    </div>
  );
};

export default ImageGallery;
